<!-- <div class="analytics-portlet-Img100p display-preroll-carousel-height"> -->
<div class="analytics-portlet o-block u-width-100p _u-width-100p u-bg-primary u-color-white-900 c-portlet_box_specs">
    <div class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
         style="position: relative;">
        <div class="o-stack__cell portlet-subheader-wrapper">
            <!--<h5>{{displayData.title}}</h5>-->
            <h5 class="portlet-subheader">{{title}} Creative</h5>
            <h6 class="portlet-subheader" style="font-size: 1.1em;">{{setDisplayProperties.name}}</h6>
            <h6 *ngIf="setDisplayProperties && setDisplayProperties.thumbnail==''"  style="font-size: 1.1em;" class="portlet-subheader">
                No Data
            </h6>

        </div>
    </div>
    <div class="c-portlet__content u-pt-small" style="width:100%; position: relative;">
        <div *ngIf="setDisplayProperties && setDisplayProperties.thumbnail == ''">
            <div class="placeholder_image">
                <img [src]="placeholderImage" class="lift-trend-no-data-placeholder" style="width: 80%"/>
            </div>
        </div>
        <div *ngIf="setDisplayProperties && setDisplayProperties.thumbnail !=''">

            <div class="o-stack__cell" style="position:absolute; width: 100%; height: 100%; z-index: 1001;"
                 *ngIf="setDisplayProperties && setDisplayProperties.thumbnail!='' && carouselItemsLength > 1">
                <div class="o-stack o-stack--center o-stack--nowrap" style="width: 100%; height: 100%; position: relative;">
                    <div class="o-stack__cell u-relative" style="width:100%; height: 100%;">
                        <a class="u-opacity-50p" style="font-size: 5rem; position: absolute;top: 50%; transform: translateY(-50%); left: 0px;">
                        <span class="next" (click)="nextArrow()" class="carousel-arrow-style"><i style="font-size:5rem;" class="fa fa-angle-left"
                                                                                                 aria-hidden="true"></i></span></a>
                        <a class="u-opacity-50p" style="font-size: 5rem; position: absolute;top: 50%; transform: translateY(-50%); right: 0px;">
                        <span class="prev" (click)="prevArrow()" class="carousel-arrow-style"><i style="font-size:5rem;" class="fa fa-angle-right"
                                                                                                 aria-hidden="true"></i></span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="o-stack o-stack__center  o-stact_ImgSpecs">
                <div class="{{slideClassNames.ClassName}}" *ngIf="slideClassNames">
                    <div class="overview_Sub_head_Img" [ngStyle]="{'background-image': 'url('+setDisplayProperties.thumbnail+')'}"></div>
                    <!--<img src="{{setDisplayProperties.thumbnail}}" *ngIf="setDisplayProperties.thumbnail!=''"  class="overview_Sub_head_Img"/>-->
                </div>
            </div>
            <div style="padding: 8px 0px;">
                <div class="o-stack o-stack__center" class="overview-carousel-bottom-section" style="display: block"
                     *ngIf="setDisplayProperties.thumbnail!=''">
                    <div style="display: block; width: 100%; margin-left: 10px;">
                        <div class="o-stack__cell  stack_sub-Block">
                        <span class="u-font-tiny  u-opacity-80p u-mt-Pcolor u-fw-bold">{{setDisplayProperties.impressions|formatNumber}} <span
                                class="u-fw-light">Impressions, </span></span>
                        </div>
                        <div *ngIf="title == 'Display' " class="o-stack__cell  stack_sub-Block">
                            <span class="u-font-tiny  u-opacity-80p u-mt-Pcolor u-fw-bold">{{setDisplayProperties.ad_interactions|formatNumber}}
                                <span class="u-fw-light">Ad Interactions</span>
                            </span>
                        </div>
                        <div *ngIf="title == 'Pre Roll' " class="o-stack__cell  stack_sub-Block">
                            <span class="u-font-tiny  u-opacity-80p u-mt-Pcolor u-fw-bold">{{setDisplayProperties.completion|formatNumber}}
                                <span class="u-fw-light">Completions</span>
                            </span>
                        </div>
                    </div>
                    <div style="display: block; width: 100%; margin-left: 10px;">
                        <div *ngIf="title == 'Display' " class="o-stack__cell  stack_sub-Block">
                            <span class="u-font-tiny  u-opacity-80p u-mt-Pcolor u-fw-bold">{{setDisplayProperties.interaction_rate|formatNumber}}%
                                 <span class="u-fw-light" *ngIf="title == 'Display' ">Ad Interaction Rate,  </span>
                                </span>
                        </div>
                        <div *ngIf="title == 'Pre Roll' " class="o-stack__cell  stack_sub-Block">
                                <span class="u-font-tiny  u-opacity-80p u-mt-Pcolor u-fw-bold">{{setDisplayProperties.completion_rate|formatNumber}}%
                                     <span class="u-fw-light">Completion Rate, </span>
                                    </span>
                        </div>
                        <div class="o-stack__cell stack_sub-Block ">
                        <span class="u-font-tiny  u-opacity-80p u-mt-Pcolor u-fw-bold">{{setDisplayProperties.clicks|formatNumber}} <span
                                class="u-fw-light">Clicks, </span></span>
                        </div>
                        <div class="o-stack__cell  stack_sub-Block">
                        <span class="u-font-tiny  u-opacity-80p u-mt-Pcolor u-fw-bold">{{setDisplayProperties.click_rate|formatNumber}}% <span
                                class="u-fw-light">Click Rate</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<!-- </div> -->
<style>
    .stack_sub-Block {
        display: inline;
        padding: 0px !important;
        line-height: unset !important;
    }

    .stack_sub-Block .u-font-tiny {
        font-size: 1.2em;
    }

    .stack_sub-Block .u-fw-light {
        font-style: italic;
    }
</style>